// Vertalingen voor de mobiele productie-invoer (productiemedewerkers).
// Product-, grondstof- en hulpstofnamen worden NOOIT vertaald.
export const LANGS = [
  { code: "nl", label: "NL" },
  { code: "ro", label: "RO" },
  { code: "pl", label: "PL" },
];

export const TR = {
  nl: {
    title: "Productie invoer",
    offline: "Offline",
    install: "Installeer als app op dit toestel",
    offlineNoData: "Offline — verbind met internet om producten/lijnen te laden. Je kunt daarna ook offline invoeren.",
    loading: "Laden…",
    basis: "Basis",
    datum: "Datum",
    lijn: "Lijn",
    kiesLijn: "— kies lijn —",
    product: "Product",
    kiesProduct: "— kies product —",
    productieUitval: "Productie & uitval",
    geproduceerd: "Geproduceerd kg",
    uitval: "Uitval kg",
    mensen: "Aantal mensen",
    uren: "Productie-uren",
    stilstand: "Stilstand uren",
    kruiden: "Kruiden kg",
    coating: "Verbruik coating (kg)",
    kg: "kg",
    coatingNote: "Grondstof en prijzen worden door de bedrijfsleiding aangevuld.",
    fotos: "Foto's (storing / uitval)",
    fotoToevoegen: "Foto toevoegen",
    scanForm: "Formulier scannen (AI)", scanBezig: "Scannen\u2026", scanHint: "Maak een foto van het ingevulde papieren formulier; de getallen worden automatisch ingevuld. Controleer daarna de waarden.", scanKlaar: "Formulier gescand \u2014 controleer de waarden", scanFout: "Scannen mislukt: ",
    modeDefinitief: "Definitief", modeConcept: "Concept", nuDefinitief: "Invoer is nu definitief", conceptBadge: "Concept", definitiefMaken: "Definitief maken",
    bezig: "Bezig…",
    wachtSync: "wacht op sync",
    opmerking: "Opmerking",
    opmerkingPlaceholder: "Bijv. storing 30 min op lijn 1",
    laatst: "Laatst ingevoerd",
    nietsIngevoerd: "Nog niets ingevoerd.",
    wachtSynchronisatie: "wacht op synchronisatie",
    uitvalKort: "uitval",
    fotosWord: "foto's",
    opslaan: "Productie opslaan",
    opslaanOffline: "Opslaan (offline)",
    opslaanBezig: "Opslaan…",
    savedOnline: "Productie opgeslagen ✓",
    savedOffline: "Lokaal opgeslagen — sync volgt zodra er verbinding is",
    savedQueued: "Lokaal bewaard — sync volgt",
    valLijnProduct: "Kies eerst een lijn en een product.",
    valGeproduceerd: "Vul geproduceerd kg in.",
    fotoAdded: "{n} foto('s) toegevoegd",
    fotoFailed: "Foto toevoegen mislukt: ",
    synced: "Openstaande invoer gesynchroniseerd",
    planning: "Planning",
    planWeekBtn: "Deze week",
    planDagBtn: "Vandaag",
    geenPlanning: "Geen planning voor deze selectie.",
    weekAfk: "wk",
    planStart: "Start",
    planGereed: "Gereed",
    planInvoeren: "\u25B6 Start & invoeren",
    hfAddGrond: "Grondstof toevoegen",
    invoerHfToast: "\u2014 halffabricaat ingevuld. Vul door de dag hulpstoffen/uitval aan.",
    invoerToast: "gestart \u2014 vul de gegevens in.",
    statusOpen: "Open",
    statusGestart: "Gestart",
    statusGereed: "Gereed",
    planGestartTxt: "Gemarkeerd als gestart",
    planGereedTxt: "Gemarkeerd als gereed",
    planOpenTxt: "Status teruggezet naar open",
    offlinePlan: "Status wijzigen kan alleen online.",
    hfVariantHint: "Twee varianten? Zet ze als 2 aparte regels (bijv. SE/ST + regulier) — het totaalgewicht wordt opgeteld en de prijs wordt gewogen gemiddeld.",
    hfKoppelTitle: "Koppel deze grondstof(fen) aan de voorraadlijst, anders wordt de voorraad onder een nieuwe naam geboekt en klopt je tracecode-voorraad niet:",
    hfKoppelKies: "— kies bestaande grondstof —",
    hfKoppelBedoel: "Bedoel je",
    hfKoppelCorrigeer: "Corrigeer naar",
    hfScanBtn: "Tumbel/meng-formulier scannen",
    hfScanHint: "Scan de 1e pagina (voorbereiding) → de kostprijs van het halffabricaat wordt geboekt en is daarna kiesbaar als grondstof.",
    hfControleren: "Halffabricaat controleren",
    hfNaamLabel: "Halffabricaat",
    hfRondjes: "Rondjes",
    hfBeginGewicht: "Totaal begin gewicht kg",
    hfKoppelPlan: "Koppel aan geplande tumbel/meng-batch (optioneel)",
    hfNietKoppelen: "— niet koppelen —",
    hfInplannenLijn: "Inplannen op lijn (mengen/tumblen)",
    hfNietInplannen: "— niet inplannen —",
    hfDag: "Dag (mengen/tumblen)",
    catGrondstof: "Grondstof",
    catHulpstof: "Hulpstof",
    catHalffabricaat: "Halffabricaat",
    phPartijLot: "Partij/lotnummer",
    woTotaal: "totaal",
    woKostprijs: "Kostprijs",
    annuleren: "Annuleren",
    boeken: "Boeken",
    scanBezigKort: "Scan bezig…",
    pakHulpBtn: "Scan pakbon hulpstoffen (expeditie)",
    pakHulpHint: "Scan één of meer pakbonnen van hulpstoffen. Na controle worden ze toegevoegd aan de voorraad (expeditie).",
    pakGrondBtn: "Scan pakbon grondstoffen (expeditie)",
    pakGrondHint: "Scan één of meer pakbonnen van grondstoffen. Na controle worden ze toegevoegd aan de voorraad (expeditie).",
    secGrondVlees: "Grondstof / vlees",
    grondstofLabel: "Grondstof (vlees/vleugels of halffabricaat)",
    lblHalffabNog: "(halffabricaat) · nog",
    ingezetKg: "Ingezet kg",
    restantKgLbl: "Restant kg",
    restantNote1: "Werkelijk verbruikt:",
    restantNote2: "kg afgeboekt · restant",
    restantNote3: "kg blijft in voorraad voor een ander product.",
    pakControleren: "Pakbon controleren",
    pakGrondControleren: "Pakbon grondstoffen controleren",
    bestaand: "bestaand",
    nieuw: "nieuw",
    phHulpstof: "Hulpstof",
    phGrondstof: "Grondstof",
    phArtikelnr: "Artikelnr",
    phKg: "Kg",
    phPrijsKg: "Prijs/kg",
    phLeverancier: "Leverancier",
    phBatchnr: "Batchnr",
    phBatchnrLev: "Batchnr (lev. partij)",
    phEigenTrace: "Onze tracecode",
    toevoegen: "Toevoegen",
    artChg1: "Artikelnr gewijzigd:",
    artChg2: "In stamgegevens bijwerken (prijs blijft gelijk)?",
    jaBijwerken: "Ja, bijwerken",
    neeBehouden: "Nee, behouden",
    pakbonLbl: "Pakbon:",
    gebruik: "gebruik",
  },
  ro: {
    title: "Introducere producție",
    offline: "Offline",
    install: "Instalează ca aplicație pe acest dispozitiv",
    offlineNoData: "Offline — conectează-te la internet pentru a încărca produsele/liniile. După aceea poți introduce și offline.",
    loading: "Se încarcă…",
    basis: "Bază",
    datum: "Data",
    lijn: "Linie",
    kiesLijn: "— alege linia —",
    product: "Produs",
    kiesProduct: "— alege produsul —",
    productieUitval: "Producție & rebut",
    geproduceerd: "Produs kg",
    uitval: "Rebut kg",
    mensen: "Număr persoane",
    uren: "Ore producție",
    stilstand: "Ore oprire",
    kruiden: "Condimente kg",
    coating: "Consum acoperire (kg)",
    kg: "kg",
    coatingNote: "Materia primă și prețurile sunt completate de conducere.",
    fotos: "Fotografii (defecțiune / rebut)",
    fotoToevoegen: "Adaugă fotografie",
    bezig: "Se procesează…",
    wachtSync: "așteaptă sincronizare",
    opmerking: "Observație",
    opmerkingPlaceholder: "Ex.: defecțiune 30 min pe linia 1",
    laatst: "Ultimele introduse",
    nietsIngevoerd: "Nimic introdus încă.",
    wachtSynchronisatie: "așteaptă sincronizarea",
    uitvalKort: "rebut",
    fotosWord: "fotografii",
    opslaan: "Salvează producția",
    opslaanOffline: "Salvează (offline)",
    opslaanBezig: "Se salvează…",
    savedOnline: "Producție salvată ✓",
    savedOffline: "Salvat local — se sincronizează când există conexiune",
    savedQueued: "Salvat local — urmează sincronizarea",
    valLijnProduct: "Alege mai întâi o linie și un produs.",
    valGeproduceerd: "Introdu kg produse.",
    fotoAdded: "{n} fotografie(i) adăugate",
    fotoFailed: "Adăugarea fotografiei a eșuat: ",
    synced: "Intrările în așteptare au fost sincronizate",
    planning: "Planificare",
    planWeekBtn: "Săptămâna aceasta",
    planDagBtn: "Astăzi",
    geenPlanning: "Nicio planificare pentru această selecție.",
    weekAfk: "săpt.",
    planStart: "Start",
    planGereed: "Gata",
    planInvoeren: "\u25B6 Start & completare",
    hfAddGrond: "Adaug\u0103 materie prim\u0103",
    invoerHfToast: "\u2014 semifabricat completat. Ad\u0103uga\u021Bi auxiliare/de\u0219euri pe parcursul zilei.",
    invoerToast: "\u00EEnceput \u2014 completa\u021Bi datele.",
    statusOpen: "Deschis",
    statusGestart: "Început",
    statusGereed: "Gata",
    planGestartTxt: "Marcat ca început",
    planGereedTxt: "Marcat ca gata",
    planOpenTxt: "Status resetat la deschis",
    offlinePlan: "Modificarea statusului este posibilă doar online.",
    hfVariantHint: "Două variante? Adaugă-le ca 2 rânduri separate (ex. SE/ST + regular) — greutatea totală se adună, iar prețul este media ponderată.",
    hfKoppelTitle: "Asociază aceste materii prime cu lista de stoc, altfel stocul se înregistrează sub un nume nou și stocul pe cod de trasabilitate nu va fi corect:",
    hfKoppelKies: "— alege materia primă existentă —",
    hfKoppelBedoel: "Ai vrut să spui",
    hfKoppelCorrigeer: "Corectează la",
    hfScanBtn: "Scanează formular tumbler/mixare",
    hfScanHint: "Scanează prima pagină (pregătire) → costul semifabricatului este înregistrat și devine selectabil ca materie primă.",
    hfControleren: "Verifică semifabricatul",
    hfNaamLabel: "Semifabricat",
    hfRondjes: "Ture",
    hfBeginGewicht: "Greutate totală inițială kg",
    hfKoppelPlan: "Asociază cu lotul tumbler/mixare planificat (opțional)",
    hfNietKoppelen: "— fără asociere —",
    hfInplannenLijn: "Planifică pe linie (mixare/tumbler)",
    hfNietInplannen: "— fără planificare —",
    hfDag: "Zi (mixare/tumbler)",
    catGrondstof: "Materie primă",
    catHulpstof: "Auxiliar",
    catHalffabricaat: "Semifabricat",
    phPartijLot: "Nr. lot/șarjă",
    woTotaal: "total",
    woKostprijs: "Cost",
    annuleren: "Anulează",
    boeken: "Înregistrează",
    scanBezigKort: "Scanare…",
    pakHulpBtn: "Scanează aviz auxiliare (recepție)",
    pakHulpHint: "Scanează unul sau mai multe avize de auxiliare. După verificare se adaugă în stoc (recepție).",
    pakGrondBtn: "Scanează aviz materii prime (recepție)",
    pakGrondHint: "Scanează unul sau mai multe avize de materii prime. După verificare se adaugă în stoc (recepție).",
    secGrondVlees: "Materie primă / carne",
    grondstofLabel: "Materie primă (carne/aripi sau semifabricat)",
    lblHalffabNog: "(semifabricat) · încă",
    ingezetKg: "Utilizat kg",
    restantKgLbl: "Rest kg",
    restantNote1: "Consumat efectiv:",
    restantNote2: "kg scăzut · rest",
    restantNote3: "kg rămân în stoc pentru alt produs.",
    pakControleren: "Verifică avizul",
    pakGrondControleren: "Verifică avizul de materii prime",
    bestaand: "existent",
    nieuw: "nou",
    phHulpstof: "Auxiliar",
    phGrondstof: "Materie primă",
    phArtikelnr: "Nr. articol",
    phKg: "Kg",
    phPrijsKg: "Preț/kg",
    phLeverancier: "Furnizor",
    phBatchnr: "Nr. lot",
    phBatchnrLev: "Nr. lot (lot furnizor)",
    phEigenTrace: "Codul nostru de trasabilitate",
    toevoegen: "Adaugă",
    artChg1: "Nr. articol modificat:",
    artChg2: "Actualizezi în datele de bază (prețul rămâne)?",
    jaBijwerken: "Da, actualizează",
    neeBehouden: "Nu, păstrează",
    pakbonLbl: "Aviz:",
    gebruik: "folosește",
  },
  pl: {
    title: "Wprowadzanie produkcji",
    offline: "Offline",
    install: "Zainstaluj jako aplikację na tym urządzeniu",
    offlineNoData: "Offline — połącz się z internetem, aby wczytać produkty/linie. Potem możesz wprowadzać także offline.",
    loading: "Ładowanie…",
    basis: "Podstawowe",
    datum: "Data",
    lijn: "Linia",
    kiesLijn: "— wybierz linię —",
    product: "Produkt",
    kiesProduct: "— wybierz produkt —",
    productieUitval: "Produkcja i odpady",
    geproduceerd: "Wyprodukowano kg",
    uitval: "Odpad kg",
    mensen: "Liczba osób",
    uren: "Godziny produkcji",
    stilstand: "Godziny przestoju",
    kruiden: "Przyprawy kg",
    coating: "Zużycie panierki (kg)",
    kg: "kg",
    coatingNote: "Surowce i ceny uzupełnia kierownictwo.",
    fotos: "Zdjęcia (awaria / odpad)",
    fotoToevoegen: "Dodaj zdjęcie",
    bezig: "Przetwarzanie…",
    wachtSync: "czeka na synchronizację",
    opmerking: "Uwaga",
    opmerkingPlaceholder: "Np. awaria 30 min na linii 1",
    laatst: "Ostatnio wprowadzone",
    nietsIngevoerd: "Jeszcze nic nie wprowadzono.",
    wachtSynchronisatie: "czeka na synchronizację",
    uitvalKort: "odpad",
    fotosWord: "zdjęcia",
    opslaan: "Zapisz produkcję",
    opslaanOffline: "Zapisz (offline)",
    opslaanBezig: "Zapisywanie…",
    savedOnline: "Produkcja zapisana ✓",
    savedOffline: "Zapisano lokalnie — synchronizacja po połączeniu",
    savedQueued: "Zapisano lokalnie — synchronizacja wkrótce",
    valLijnProduct: "Najpierw wybierz linię i produkt.",
    valGeproduceerd: "Wpisz kg produkcji.",
    fotoAdded: "Dodano {n} zdjęcie(a)",
    fotoFailed: "Dodanie zdjęcia nie powiodło się: ",
    synced: "Oczekujące wpisy zsynchronizowane",
    planning: "Plan",
    planWeekBtn: "Ten tydzień",
    planDagBtn: "Dzisiaj",
    geenPlanning: "Brak planu dla tego wyboru.",
    weekAfk: "tydz.",
    planStart: "Start",
    planGereed: "Gotowe",
    planInvoeren: "\u25B6 Start i wprowad\u017A",
    hfAddGrond: "Dodaj surowiec",
    invoerHfToast: "\u2014 p\u00F3\u0142produkt uzupe\u0142niony. Uzupe\u0142niaj dodatki/odpady w ci\u0105gu dnia.",
    invoerToast: "rozpocz\u0119to \u2014 uzupe\u0142nij dane.",
    statusOpen: "Otwarte",
    statusGestart: "Rozpoczęte",
    statusGereed: "Gotowe",
    planGestartTxt: "Oznaczono jako rozpoczęte",
    planGereedTxt: "Oznaczono jako gotowe",
    planOpenTxt: "Status przywrócony do otwartego",
    offlinePlan: "Zmiana statusu możliwa tylko online.",
    hfVariantHint: "Dwie odmiany? Dodaj je jako 2 osobne wiersze (np. SE/ST + zwykły) — łączna waga jest sumowana, a cena to średnia ważona.",
    hfKoppelTitle: "Powiąż te surowce z listą magazynową, w przeciwnym razie zapas zostanie zaksięgowany pod nową nazwą i stan wg kodu partii nie będzie się zgadzać:",
    hfKoppelKies: "— wybierz istniejący surowiec —",
    hfKoppelBedoel: "Czy chodziło o",
    hfKoppelCorrigeer: "Popraw na",
    hfScanBtn: "Skanuj formularz tumblera/mieszania",
    hfScanHint: "Zeskanuj 1. stronę (przygotowanie) → koszt półproduktu zostaje zaksięgowany i można go potem wybrać jako surowiec.",
    hfControleren: "Sprawdź półprodukt",
    hfNaamLabel: "Półprodukt",
    hfRondjes: "Rundy",
    hfBeginGewicht: "Łączna waga początkowa kg",
    hfKoppelPlan: "Powiąż z zaplanowaną partią tumblera/mieszania (opcjonalnie)",
    hfNietKoppelen: "— nie wiązać —",
    hfInplannenLijn: "Zaplanuj na linii (mieszanie/tumbler)",
    hfNietInplannen: "— nie planować —",
    hfDag: "Dzień (mieszanie/tumbler)",
    catGrondstof: "Surowiec",
    catHulpstof: "Dodatek",
    catHalffabricaat: "Półprodukt",
    phPartijLot: "Nr partii/lotu",
    woTotaal: "razem",
    woKostprijs: "Koszt",
    annuleren: "Anuluj",
    boeken: "Zaksięguj",
    scanBezigKort: "Skanowanie…",
    pakHulpBtn: "Skanuj WZ dodatków (przyjęcie)",
    pakHulpHint: "Zeskanuj jeden lub więcej dokumentów WZ dodatków. Po sprawdzeniu zostaną dodane do magazynu (przyjęcie).",
    pakGrondBtn: "Skanuj WZ surowców (przyjęcie)",
    pakGrondHint: "Zeskanuj jeden lub więcej dokumentów WZ surowców. Po sprawdzeniu zostaną dodane do magazynu (przyjęcie).",
    secGrondVlees: "Surowiec / mięso",
    grondstofLabel: "Surowiec (mięso/skrzydełka lub półprodukt)",
    lblHalffabNog: "(półprodukt) · jeszcze",
    ingezetKg: "Użyto kg",
    restantKgLbl: "Pozostało kg",
    restantNote1: "Faktycznie zużyto:",
    restantNote2: "kg odpisano · pozostało",
    restantNote3: "kg pozostaje w magazynie na inny produkt.",
    pakControleren: "Sprawdź WZ",
    pakGrondControleren: "Sprawdź WZ surowców",
    bestaand: "istniejący",
    nieuw: "nowy",
    phHulpstof: "Dodatek",
    phGrondstof: "Surowiec",
    phArtikelnr: "Nr art.",
    phKg: "Kg",
    phPrijsKg: "Cena/kg",
    phLeverancier: "Dostawca",
    phBatchnr: "Nr partii",
    phBatchnrLev: "Nr partii (partia dostawcy)",
    phEigenTrace: "Nasz kod partii",
    toevoegen: "Dodaj",
    artChg1: "Zmieniono nr artykułu:",
    artChg2: "Zaktualizować w danych podstawowych (cena bez zmian)?",
    jaBijwerken: "Tak, aktualizuj",
    neeBehouden: "Nie, zachowaj",
    pakbonLbl: "WZ:",
    gebruik: "użyj",
  },
};
